export default {
  earlierVersion: "(earlier version)",
  latest: "(latest)",
  philter: "version-header",
  version: "version",
  viewLatestVersion: "View Latest Version"
};
